import React from 'react'
import { Tooltip  } from 'antd'
import { injectIntl } from 'react-intl'
import financeIconSprite from 'assets/img/finance/sprite.svg'
import StatusIcon from './StatusIcon'
import style from './style.module.scss'

const TypeIconMap = {
  EventByWithdrawal: 'type_withdrawal',
  EventByPayment: 'type_payment',
  EventByPayout: 'type_income',
  EventByReceipt: 'type_transaction',
  EventByRemittance: 'type_transaction',
  EventByGift: 'type_gift'
}

const FinanceEventIcon = ({ type, status, intl: { formatMessage }, ...rest }) => {
  const typeIconId = TypeIconMap[type] ? TypeIconMap[type] : 'type_other';

  return (
    <Tooltip title={formatMessage({ id: status })}>
      <div className={style.financeEventIcon} {...rest}>
        <svg className={style.typeIcon}>
          <use href={`${financeIconSprite}#${typeIconId}`} />
        </svg>
        <StatusIcon status={status} className={style.statusIcon} />
      </div>
    </Tooltip>
  )
}

export default injectIntl(FinanceEventIcon)
